import { Table, TableKeyValue } from "./Table";

export const RawJSONTable = ({ data }) => {
  return (
    <Table>
      {Object.keys(data).map((key) => {
        return <TableKeyValue label={key}>{data[key]}</TableKeyValue>;
      })}
    </Table>
  );
};
